import {t} from './i18n.js';

let deviceEnum = {
  'LOGIC_4_DEVICE': 0,
  'LOGIC_8_DEVICE': 1,
  'LOGIC_PRO_8_DEVICE': 2,
  'LOGIC_PRO_16_DEVICE': 3
};
let deviceEnumName = [
  'LOGIC_4_DEVICE', 'LOGIC_8_DEVICE', 'LOGIC_PRO_8_DEVICE',
  'LOGIC_PRO_16_DEVICE'
];
let deviceName = ['Logic4', 'Logic8', 'LogicPro8', 'LogicPro16'];

let settings = new function() {
  this.active_digital_channels = 8;
  this.active_analog_channels = 8;
  this.active_device = deviceEnum.LOGIC_PRO_8_DEVICE;

  this.current_digital_sample_rate = 0;
  this.current_analog_sample_rate = 0;

  this.DigitalSampleRates = [12000000, 6000000, 3000000, 1000000];
  this.AnalogSampleRates = [6000000];

  this.data_density = 0.0005;
  this.memory_amount = 8;
};

/*
let deviceSettings = [
    Logic4 = new function () {
        this.NumAnalogChannels = 1;
        this.NumDigitalChannels = 4;

    },
    Logic8 = new function () {
        this.NumAnalogChannels = 8;
        this.NumDigitalChannels = 8;
    },
    LogicPro8 = new function () {
        this.NumAnalogChannels = 8;
        this.NumDigitalChannels = 8;
    },
    LogicPro16 = new function () {
        this.NumAnalogChannels = 16;
        this.NumDigitalChannels = 16;
    }
];
*/

let densityOptions = [0.0005, 0.01, 0.125, 0.25];

let e, d;
function init() {
  if (!window.location.href.includes('/performance-calculator')) return;

  Calculator.init();

  $(window).resize(function() {
    if ($('.calculator').length) {
      Calculator.size();
    }
  });

  /*****************************************/
  /*************Switch Device***************/
  /*****************************************/
  $('.calculator__device-item').click(function() {
    if (!$(this).hasClass('selected')) {
      $(this)
          .siblings('.calculator__device-item.selected')
          .removeClass('selected');
      $(this).addClass('selected');
      DeviceChanged($(this).index() + 1);
      SaleaeTrackEvent(
          'Interactive Capabilities',
          'Device Clicked ' + deviceName[$(this).index() + 1],
          'Interactive Capabilities Device Clicked',
          {'Device': deviceName[$(this).index() + 1]});
    }
  });

  /*****************************************/
  /************Active Channels**************/
  /*****************************************/
  let mouseDown = false;
  let setOn = true;

  $('#ds-channels-table')
      .on('mousedown', '.digital-channel, .analog-channel', function() {
        mouseDown = true;
        if ($(this).hasClass('selected')) {
          if ((settings.active_analog_channels +
               settings.active_digital_channels) > 1) {
            $(this).removeClass('selected');
            if ($(this).hasClass('digital-channel')) {
              settings.active_digital_channels--;
            } else if ($(this).hasClass('analog-channel')) {
              settings.active_analog_channels--;
            }
            setOn = false;
          } else {
            setOn = true;
          }
        } else {
          $(this).addClass('selected');
          if ($(this).hasClass('digital-channel')) {
            settings.active_digital_channels++;
          } else if ($(this).hasClass('analog-channel')) {
            settings.active_analog_channels++;
          }
          setOn = true;
        }
        NumChannelsChanged();
        SaleaeTrackEvent(
            'Interactive Capabilities', 'Channels Changed',
            'Interactive Capabilities Channels Changed');
      });


  $('#ds-channels-table')
      .on('mouseenter', '.digital-channel, .analog-channel', function() {
        if (mouseDown) {
          if ($(this).hasClass('selected') && setOn == false) {
            if ((settings.active_analog_channels +
                 settings.active_digital_channels) > 1) {
              $(this).removeClass('selected');
              if ($(this).hasClass('digital-channel')) {
                settings.active_digital_channels--;
              } else if ($(this).hasClass('analog-channel')) {
                settings.active_analog_channels--;
              }
            }
          } else if (!$(this).hasClass('selected') && setOn == true) {
            $(this).addClass('selected');
            if ($(this).hasClass('digital-channel')) {
              settings.active_digital_channels++;
            } else if ($(this).hasClass('analog-channel')) {
              settings.active_analog_channels++;
            }
          }
          NumChannelsChanged();
        }
      });

  $('html').on('mouseup', 'body', function() {
    mouseDown = false;
  });

  $('#ds-channels-table').on('click', '.clear-channels', function() {
    let $parent = $(this).parent();

    if ($parent.hasClass('digital-channels')) {
      settings.active_digital_channels = settings.active_digital_channels -
          $parent.children('.digital-channel.selected').length;
      $parent.children('.digital-channel.selected').removeClass('selected');

      if ((settings.active_analog_channels +
           settings.active_digital_channels) == 0) {
        $('.digital-channels .digital-channel').first().addClass('selected');
        settings.active_digital_channels++;
      }
    }

    if ($parent.hasClass('analog-channels')) {
      settings.active_analog_channels = settings.active_analog_channels -
          $parent.children('.analog-channel.selected').length;
      $parent.children('.analog-channel.selected').removeClass('selected');

      if ((settings.active_analog_channels +
           settings.active_digital_channels) == 0) {
        $('.analog-channels .analog-channel').first().addClass('selected');
        settings.active_analog_channels++;
      }
    }

    NumChannelsChanged();
  });

  /*****************************************/
  /*************Span DropDown***************/
  /*****************************************/
  $('.dropdown-selected').click(function() {
    // Do nothing is disabled
    if ($(this).parent().hasClass('disabled')) return;

    if (!$(this).next('.dropdown-container').is(':visible')) {
      // Resest other DDs
      $('.dropdown-container').hide();
      $('.dropdown-container').css('z-index', '2');
      //$('.dropdown-selected').css("z-index", "3");

      // Set up current DD
      $(this).css('z-index', '5');
      $(this).next('.dropdown-container').css('z-index', '4');
      $(this).next('.dropdown-container').show();
      let orginal_height = $(this).next('.dropdown-container').css('height');

      $(this).next('.dropdown-container').css('height', '0');
      $(this)
          .next('.dropdown-container')
          .animate({height: orginal_height}, 200);
    } else {
      $(this)
          .next('.dropdown-container')
          .animate({height: '0'}, 200, function() {
            $(this).hide();
            $(this).css('height', 'auto');
            $(this).css('z-index', '2');
            $(this).parent('.dropdown-selected').css('z-index', '3');
          });

      //$('.dropdown-container').hide();
      //$(this).next('.dropdown-container').css("height", "auto");
      //$(this).next('.dropdown-container').slideUp(200);
    }
  });

  $('.ds-dd-field').on('mouseleave', function() {
    $('#page').on('click', function() {
      if ($('.dropdown-container').is(':visible')) {
        $('.dropdown-container').animate({height: '0'}, 200, function() {
          $(this).hide();
          $(this).css('height', 'auto');
          $(this).css('z-index', '2');
          $(this).parent('.dropdown-selected').css('z-index', '3');
        });
      }
    });
  });
  $('.ds-dd-field').on('mouseenter', function() {
    $('#page').off('click');
  });

  $('.dropdown-container').on('mouseenter', '.option', function() {
    $('.dropdown-container .option.selected').removeClass('selected');
    $(this).addClass('selected');
  });

  $('.dropdown-container').on('click', '.option', function(e) {
    let real_click = false
    if (e.hasOwnProperty('originalEvent')) {
      real_click = true;
    }

    $(this)
        .parent('.dropdown-container')
        .prev('.dropdown-selected')
        .html($(this).clone());
    if ($('.dropdown-container').is(':visible')) {
      $('.dropdown-container').animate({height: '0'}, 200, function() {
        $(this).hide();
        $(this).css('height', 'auto');
        $(this).css('z-index', '2');
        //$(this).parent('.dropdown-selected').css("z-index", "3");
      });
    }

    // Set Sample Rate or Duration
    let index = $(this).index();
    let $parent = $(this).parents('.dropdown-wrapper');
    if ($parent.is('#sample-rate-dd')) {
      if (settings.active_digital_channels > 0) {
        settings.current_digital_sample_rate =
            settings.DigitalSampleRates[index];
      } else {
        settings.current_digital_sample_rate = 0;
      }
      if (settings.active_analog_channels > 0) {
        settings.current_analog_sample_rate = settings.AnalogSampleRates[index];
      } else {
        settings.current_analog_sample_rate = 0;
      }
      SampleRateOptionsChanged();
      if (real_click === true) {
        SaleaeTrackEvent(
            'Interactive Capabilities', 'Sample Rate Changed',
            'Interactive Capabilities Sample Rate Changed');
      }

    } else if ($parent.is('#data-density-dd')) {
      settings.data_density = densityOptions[index];
      SettingsChanged();
      if (real_click === true) {
        SaleaeTrackEvent(
            'Interactive Capabilities', 'Density Changed',
            'Interactive Capabilities Density Changed');
      }
    } else if ($parent.is('#memory-amount-dd')) {
      settings.memory_amount = parseInt($(this).text());
      SettingsChanged();
      if (real_click === true) {
        SaleaeTrackEvent(
            'Interactive Capabilities', 'Memory Changed',
            'Interactive Capabilities Memory Changed');
      }
    }
  });

  ///**Prevent Window Scroll on dd**/
  //$('.dropdown-container').bind('mousewheel', function (e, d) {
  //    let height = $(this).height();
  //    let scrollHeight = $(this).get(0).scrollHeight;
  //    if ((this.scrollTop === (scrollHeight - height) && d < 0) ||
  //    (this.scrollTop === 0 && d > 0)) {
  //        e.preventDefault();
  //    }
  //});

  DeviceChanged(deviceEnum.LOGIC_PRO_8_DEVICE);
};


function DeviceChanged(index) {
  settings.active_device = index;

  /*Change Header*/
  $('#ds-header-panel h6 span').text(deviceName[index])

  SetChannelsOptions();
}

function SetChannelsOptions() {
  switch (settings.active_device) {
    case deviceEnum.LOGIC_4_DEVICE:
      $('#ds-channels-table').html($('#logic-4-device-template').html());
      break;
    case deviceEnum.LOGIC_8_DEVICE:
      $('#ds-channels-table').html($('#logic-8-device-template').html());
      break;
    case deviceEnum.LOGIC_PRO_8_DEVICE:
      $('#ds-channels-table').html($('#logic-pro-8-device-template').html());
      break;
    case deviceEnum.LOGIC_PRO_16_DEVICE:
      $('#ds-channels-table').html($('#logic-pro-16-device-template').html());
      break;
  };

  if (settings.active_device == deviceEnum.LOGIC_4_DEVICE ||
      settings.active_device == deviceEnum.LOGIC_8_DEVICE) {
    settings.active_digital_channels = 4;
    settings.active_analog_channels = 1;
  } else if (settings.active_device == deviceEnum.LOGIC_PRO_8_DEVICE) {
    settings.active_digital_channels = 5;
    settings.active_analog_channels = 3;
  } else {
    settings.active_digital_channels = 13;
    settings.active_analog_channels = 3;
  }

  NumChannelsChanged();
}

function NumChannelsChanged() {
  SetSampleRateOptions();
}

function SetSampleRateOptions() {
  let new_options = '';
  let prev_option = $('#sample-rate-dd .dropdown-selected').text();
  let digital_rates, analog_rates;
  let sample_rate_options = new Array();
  let options = {
    url: 'https://www.saleae.com/getsamplerateoptions' +
        '?device_type=' + deviceEnumName[settings.active_device] +
        '&digital_channel_count=' + settings.active_digital_channels +
        '&analog_channel_count=' + settings.active_analog_channels,
    type: 'get'
  };
  $.ajax(options).done(function(data) {
    digital_rates = data.digital_rates;
    analog_rates = data.analog_rates;
    settings.DigitalSampleRates = digital_rates;
    settings.AnalogSampleRates = analog_rates;

    if (settings.active_analog_channels == 0)  // Digital Only
    {
      for (let i = 0; i < digital_rates.length; i++) {
        sample_rate_options.push(
            '<span class=\'digital-option\'>' +
            GetSampleConversion(digital_rates[i]) + '</span>');
      }
    } else if (settings.active_digital_channels == 0)  // Analog only
    {
      for (let i = 0; i < analog_rates.length; i++) {
        sample_rate_options.push(
            '<span class=\'analog-option\'>' +
            GetSampleConversion(analog_rates[i]) + '</span>');
      }
    } else {  // Mixed Mode
      for (let i = 0; i < digital_rates.length && i < analog_rates.length;
           i++) {
        sample_rate_options.push(
            '<span class=\'digital-option\'>' +
            GetSampleConversion(digital_rates[i]) + '</span> ' +
            '<span class=\'analog-option\'>' +
            GetSampleConversion(analog_rates[i]) + '</span>')
      }
    }


    for (let i = 0; i < sample_rate_options.length; i++) {
      new_options +=
          '<span class=\'option\'>' + sample_rate_options[i] + ' </span>\n'
    }
    $('#sample-rate-dd .dropdown-container').html(new_options);
    if ($('#sample-rate-dd .dropdown-container span.selected').length == 0) {
      $('#sample-rate-dd .dropdown-container span').first().trigger('click');
    } else {
      SampleRateOptionsChanged();
    }
  });
}

function SampleRateOptionsChanged() {
  SetDataDensityOptions();
}

function SetDataDensityOptions() {
  let digital_sample_rate = settings.current_digital_sample_rate;

  let sparse_toggles =
      DataDensityConvert(digital_sample_rate * densityOptions[0]);
  let moderate_toggles =
      DataDensityConvert(digital_sample_rate * densityOptions[1]);
  let heavy_toggles =
      DataDensityConvert(digital_sample_rate * densityOptions[2]);
  let extreme_toggles =
      DataDensityConvert(digital_sample_rate * densityOptions[3]);

  let spi_rate_1 =
      DataDensityConvert(digital_sample_rate * densityOptions[1] / 2);
  let spi_rate_2 =
      DataDensityConvert(digital_sample_rate * densityOptions[2] / 2);


  $('#sal-option-1').text(t('calc-my-data-sparse', {'num': sparse_toggles}));
  $('#sal-option-2')
      .text(t(
          'calc-my-data-moderate', {num: moderate_toggles, rate: spi_rate_1}));
  $('#sal-option-3')
      .text(t('calc-my-data-heavy', {num: heavy_toggles, rate: spi_rate_2}));
  $('#sal-option-4').text(t('calc-my-data-extreme', {num: extreme_toggles}));
  /*
      $('#data-density-dd .dropdown-container').html("\
              <span class='option'><span class='option-value'>Sparse -- I2C, or
     infrequent SPI -- (<var>" + DataDensityConvert(digital_sample_rate *
     densityOptions[0]) + "</var> toggles/sec)</span></span>\
              <span class='option'><span class='option-value'>Moderate (e.g.
     <var>" + DataDensityConvert(digital_sample_rate * densityOptions[1] / 2) +
     "</var>Hz SPI, 50% idle) -- (" + DataDensityConvert(digital_sample_rate *
     densityOptions[1]) + " toggles/sec)</span></span>\
              <span class='option'><span class='option-value'>Heavy  <var>" +
     DataDensityConvert(digital_sample_rate * densityOptions[2] / 2) +
     "</var>Hz+ SPI, 0% idle -- (" + DataDensityConvert(digital_sample_rate *
     densityOptions[2]) + " toggles/sec)</span></span>\ <span
     class='option'><span class='option-value'>Extreme – Maximum theoretical
     (<var>" + DataDensityConvert(digital_sample_rate * densityOptions[3]) +
     "</var> toggles/sec)</span></span>");
  */
  $('#data-density-dd .dropdown-container .option:first-of-type')
      .trigger('click');

  if (digital_sample_rate == 0)
    $('#data-density-dd').addClass('disabled');
  else
    $('#data-density-dd').removeClass('disabled');
}

function GetSampleConversion(int_val) {
  if (!Number(int_val)) return 0;
  let converted_value;
  let unit;

  if (int_val >= 1000000000) {
    converted_value = (int_val / 1000000000).toString();
    unit = 'GS/s';
  } else if (int_val >= 1000000) {
    converted_value = (int_val / 1000000).toString();
    unit = 'MS/s';
  } else if (int_val >= 1000) {
    converted_value = (int_val / 1000).toString();
    unit = 'KS/s';
  } else {
    converted_value = int_val;
    unit = 'S/s';
  }


  return '<span class=\'option-value\'>' + converted_value +
      '</span> <span class=\'option-unit\'>' + unit + '</span>';
}

function SettingsChanged() {
  // Get Sample Rates
  let digital_sample_rate = settings.current_digital_sample_rate;
  let analog_sample_rate = settings.current_analog_sample_rate;

  // Get Num Channels
  let num_digital_channels = settings.active_digital_channels;
  let num_analog_channels = settings.active_analog_channels;

  // Get Memory Amount
  let memory_amount = settings.memory_amount;

  // Get Data Density
  let data_density = settings.data_density;

  // FOr section commented out at bottom of html page - for testing purposes, do
  // not remove
  $('#num-digital-channels span').text(num_digital_channels.toString());
  $('#num-analog-channels span').text(num_analog_channels.toString());
  $('#digital-sample-rate span').text(digital_sample_rate.toString());
  $('#analog-sample-rate span').text(analog_sample_rate.toString());
  $('#amount-of-memory span').text(memory_amount.toString());
  $('#data-density span').text(data_density.toString());

  // Memory calculations are in bits.
  let dig_mem_per_sec =
      (num_digital_channels * digital_sample_rate * 8 *
       data_density) /*theoretical max */;
  let ana_mem_per_sec = num_analog_channels * analog_sample_rate * 16 * 4;
  let total_mem_per_sec = dig_mem_per_sec + ana_mem_per_sec;

  // memory_amount is in bits.
  let total_seconds_sampling =
      1024 * 1024 * 1024 * 8 * memory_amount / total_mem_per_sec;


  let total_converting_sample_time = TimeConvert(total_seconds_sampling);
  let time_unit = TimeUnitConvert(total_seconds_sampling);

  /*
      let formatted_record_length =
     parseFloat(total_converting_sample_time).toFixed(2).toString(); if
     (formatted_record_length[formatted_record_length.length - 1] == 0) {
          formatted_record_length = formatted_record_length.substring(0,
     formatted_record_length.length - 1); if
     (formatted_record_length[formatted_record_length.length - 1] == 0) {
              formatted_record_length = formatted_record_length.substring(0,
     formatted_record_length.length - 2);
          }
      }

      let record_length_content = "You can
     record...&nbsp;&nbsp;&nbsp;&nbsp;<var>"; for (let i = 0; i <
     formatted_record_length.length; i++) { if (formatted_record_length[i] !=
     '.') record_length_content += "<span class='ticker'>" +
     formatted_record_length[i] + "</span> "; else record_length_content +=
     "<span style='color: #439DD1; line-height: 10%; font-size: 40px;
     font-family: \"Roboto\", sans-serif !important;'>" +
     formatted_record_length[i] + "</span> ";
      }
      record_length_content += "</var>&nbsp;&nbsp;" + time_unit;
      $('#record-length').html(record_length_content);
  */

  let record_length_content = `${t('calc-you-can-record')} ${
      total_converting_sample_time} ${time_unit}`;

  $('#record-length').html(record_length_content);
}

function DataDensityConvert(num) {
  if (!Number(num) && num != 0) return false;

  // Hard limit to max theoretical 100MS/s
  if (num > 100000000) num = 100000000;

  let unit_string;
  if (num >= 1000000) {
    unit_string = 'M';
    num = (num / 1000000);
  } else if (num >= 1000) {
    unit_string = 'K';
    num = (num / 1000);
  } else {
    unit_string = '';
  }

  let formatted_num = parseFloat(num).toFixed(1).toString();
  if (formatted_num[formatted_num.length - 1] == 0) {
    formatted_num = formatted_num.substring(0, formatted_num.length - 2);
  }


  return formatted_num + ' ' + unit_string;
}

function TimeConvert(time_val) {
  if (!Number(time_val)) return false;

  let time_string;
  if (time_val >= 86400) {
    time_string = (time_val / 86400).toFixed(1);
  } else if (time_val >= 3600) {
    time_string = (time_val / 3600).toFixed(1);
  } else if (time_val >= 60) {
    time_string = (time_val / 60).toFixed(1);
  } else if (time_val >= 2) {
    time_string = time_val.toFixed(1);
  } else {
    time_string = (time_val * 1000).toFixed(0);
  }

  return time_string;
}

function TimeUnitConvert(time_val) {
  if (!Number(time_val)) return false;

  let unit_string;
  if (time_val >= 86400) {
    unit_string = t('calc-days');
  } else if (time_val >= 3600) {
    unit_string = t('calc-hours');
  } else if (time_val >= 60) {
    unit_string = t('calc-minutes');
  } else if (time_val >= 2) {
    unit_string = t('calc-seconds');
  } else {
    unit_string = t('calc-milliseconds');
  }

  return unit_string;
}

function SaleaeTrackEvent() {
  return true;
}

var Calculator = {

  init: function() {
    this.size();
    this.selectClick();
  },

  size: function() {
    var devicePanel = $('.calculator__device-panel');

    if ($(window).width() <= 479) {
      devicePanel.css({'height': ''})
    } else {
      devicePanel.css({'height': devicePanel.outerWidth() * 0.2149})
    }

    $('.calculator__data-field-select-dropdown').each(function() {
      $(this).css({'padding-top': $(this).prev().outerHeight()})
    });

    $('.calculator__rate-select-dropdown').each(function() {
      $(this).css({'padding-top': $(this).prev().outerHeight()})
    });
  },

  selectClick: function() {
    $('.calculator__data-field-select-actual, .calculator__rate-select-actual')
        .on('click', function() {
          $(this).next().toggle();
          return false;
        });
  }
};

export {
  init,
};